import Icon from './Icon';

const ShareEmail = ({ className }) => (
  <Icon name="share-email" className={className} viewBox="0 0 31 31">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1338.000000, -161.000000)">
        <g transform="translate(1145.000000, 158.000000)">
          <g transform="translate(193.000000, 3.000000)">
            <g>
              <ellipse
                fill="#EB4C36"
                cx="15.5"
                cy="15.6303766"
                rx="15.5"
                ry="15.2964399"
              />
              <path
                d="M9.92526936,12.6456164 C10.2342794,12.7984511 14.5909569,15.1132147 14.7450984,15.1892732 C14.9261419,15.291163 15.1319062,15.3162767 15.3383976,15.3162767 C15.5441619,15.3162767 15.7761012,15.291163 15.9309697,15.1892732 C16.0858383,15.1132147 20.4417887,12.7984511 20.7507988,12.6456164 C21.0859837,12.4676681 21.3695458,11.9589367 20.8024216,11.9589367 L9.89982148,11.9589367 C9.30652226,11.9589367 9.61625935,12.4676681 9.92526936,12.6456164 M20.8802194,13.9178036 C20.5450344,14.095752 16.1374611,16.3595706 15.9309697,16.4614604 C15.6990305,16.5884639 15.5441619,16.5884639 15.3383976,16.5884639 C15.1319062,16.5884639 14.9770377,16.5884639 14.7450984,16.4614604 C14.5393341,16.3595706 10.1572086,14.095752 9.79657578,13.9178036 C9.53846154,13.7900826 9.53846154,13.9429173 9.53846154,14.0448071 L9.53846154,18.7252791 C9.53846154,18.979286 9.89982148,19.3359003 10.1833836,19.3359003 L20.4934116,19.3359003 C20.7769737,19.3359003 21.1376066,18.979286 21.1376066,18.7252791 L21.1376066,14.0448071 C21.1376066,13.9429173 21.1376066,13.7900826 20.8802194,13.9178036"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);

export default ShareEmail;
